// extracted by mini-css-extract-plugin
export default {"ImageRow":"style_ImageRow__zmdnD","Upper":"style_Upper__EXdYM","OrderLink":"style_OrderLink__4kdxA","Message":"style_Message__ywFCg"};